export default "__VITE_ASSET__DlFCgPh2__"